import { Effect } from "../Materials/effect";
import "./ShadersInclude/helperFunctions";
var name = 'rgbdDecodePixelShader';
var shader = "\nvarying vec2 vUV;\nuniform sampler2D textureSampler;\n#include<helperFunctions>\nvoid main(void)\n{\ngl_FragColor=vec4(fromRGBD(texture2D(textureSampler,vUV)),1.0);\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var rgbdDecodePixelShader = { name: name, shader: shader };
//# sourceMappingURL=rgbdDecode.fragment.js.map